import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import projectKeys from './keyFactory';

const GetProjectHeatLossEstimate = graphql(`
  query GetProjectHeatLossEstimate($projectId: ID!) {
    projectById(id: $projectId) {
      id
      heatLossEstimate {
        method
        peakHeatLoad
        heatPumpSizeRange {
          lowerKw
          nominalKw
          upperKw
        }
        minimumCylinderLitres
        targetIndoorTemperatureC
        recommendedHeatPumps {
          material {
            id
            name
          }
          productSpec {
            id
            name
            domesticHotWaterLitres
            hasIntegratedCylinder
          }
          heatingOutputKw
        }
        recommendedCylinders {
          material {
            id
            name
          }
          productSpec {
            id
            name
            domesticHotWaterLitres
          }
        }
      }
    }
  }
`);

const useGetProjectHeatLossEstimate = (projectId?: string) => {
  const { data, ...rest } = useQuery({
    enabled: !!projectId,
    queryKey: projectKeys.heatLossEstimate(projectId!),
    queryFn: () => {
      return gqlClient.request(GetProjectHeatLossEstimate, {
        projectId: projectId!,
      });
    },
  });
  return {
    heatLossEstimate: data?.projectById?.heatLossEstimate,
    data,
    ...rest,
  };
};

export default useGetProjectHeatLossEstimate;
